export class SortInfo {
    SortColumn: string = '';
    sortDirection: number = 0;
}
